module.exports = __webpack_public_path__ + "static/media/brokerContentTwo.401db27f.png";